<app-background *ngIf="true" [backgroundColor]="'var(--color-1)'">
</app-background>

<div class="container fade-in">

    <div class="logo-section">
        <svg class="logo" height="100" viewBox="0 0 210 49" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Group 178">
                <rect id="streak_white" x="18" y="18" width="37" height="6" rx="3" fill="white" />
                <g id="logo">
                    <rect id="streak_1" x="67" y="12" width="37" height="6" rx="3" fill="#0D7377" />
                    <rect id="streak_2" x="70" y="18" width="37" height="6" rx="3" fill="#14FFEB" />
                    <rect id="streak_3" x="73" y="24" width="37" height="6" rx="3" fill="#FFA600" />
                    <path id="prism"
                        d="M83.2535 26.75L72.4282 8C69.349 2.66667 61.651 2.66665 58.5718 7.99999L47.7465 26.75C44.6673 32.0833 48.5163 38.75 54.6747 38.75H76.3253C82.4837 38.75 86.3327 32.0834 83.2535 26.75Z"
                        fill="#323232" stroke="white" stroke-width="4" />
                </g>
                <text id="text" fill="#FFA600" xml:space="preserve" style="white-space: pre" font-family="Quicksand"
                    font-size="24" font-weight="bold" letter-spacing="0em">
                    <tspan x="115.074" y="28">prism</tspan>
                </text>
            </g>
        </svg>
    </div>

    <div class="divider"></div>

    <div [formGroup]="formGroup" class="form-section">
        <div class="text-input" *ngIf="!(passwordRecoveryMode$ | async)">
            <div class="label">email</div>
            <input id="email-form" formControlName="email" type="email" (keydown.enter)="login()">
        </div>
        <div class="text-input">
            <div class="label">{{ (passwordRecoveryMode$ | async) ? 'new password' : 'password' }}</div>
            <input formControlName="password" [type]="showPassword$.value ? 'text' : 'password'"
                (keydown.enter)="login()">
            <img [src]="showPassword$.value ? '/assets/icons/visibility_off.svg' : '/assets/icons/eye.svg'"
                class="icon-white" (click)="toggleShowPassword()">
        </div>
        <div class="button" (click)="login()" [ngClass]="{'disabled': !(submitEnabled$ | async)}">
            <div *ngIf="!(loginInProgress$ | async) && !(loginSuccessful$ | async)" class="pre">{{
                (passwordRecoveryMode$ | async) ? 'reset password' : 'login' }}</div>
            <prism-loading-bar *ngIf="(loginInProgress$ | async)" barWidth="10rem">
            </prism-loading-bar>
            <div *ngIf="(loginSuccessful$ | async)" class="logging-in">success!</div>
        </div>
    </div>
</div>

<div class="bottom-right">
    <div (click)="navigateToBadgeLoginPage()" class="button">badge login</div>
</div>